import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { changeLanguage } from 'i18next'

import { ReactComponent as Earth } from '../../../../assets/icons/earth.svg'

import styles from './language.module.scss'

const availableLanguages = [
    {
        label: 'PL',
        value: 'pl',
    },
    {
        label: 'EN',
        value: 'en',
    },
]

function Language() {
    const { i18n } = useTranslation()

    const [language, setLanguage] = useState(i18n.language)

    useEffect(() => {
        handleLanguageChange(language)
    }, [language])

    const handleLanguageChange = (languageKey: string) => {
        changeLanguage(languageKey)
    }

    return (
        <div className={styles.language}>
            <Earth className={styles.language__icon} />
            <select
                className={styles.language__select}
                value={language}
                onChange={(e) => setLanguage(e.target.value)}
            >
                {availableLanguages.map((language) => (
                    <option key={language.value} value={language.value}>
                        {language.label}
                    </option>
                ))}
            </select>
        </div>
    )
}

export default Language
